import "./index.css";
import React from "react";
import { useEffect } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { setMainPageView, goBackBoolean } from "../../redux";
import { TaskQueue } from "cwait";

import InfoComponentTop from "./components/InfoComponentTop/InfoComponentTop";
import SkeletonPlayerInformationSummary from "../Skeleton/SkeletonPlayerInformationSummary";
import "../Skeleton/SkeletonPlayerInformationSummary.css";
import GameInformation from "../Header/GameInformation/GameInformation";

import {
  get_player_projections_for_slate_id,
  get_player_projections_current,
  get_player_stats_actual_current_season,
  get_player_gamelogs_current_season,
} from "../../utils/apiUtils";
import {
  findSportByLeague,
  getUserId,
  getUserJwtToken,
} from "../../utils/utils";
import TagManager from "react-gtm-module";
import AppJS from "../../assets/app/AppJS";
import AppCSS from "../../assets/app/AppCSS";
import { getID } from "../../firebase";

function Details(props) {
  const SSID = props.routeParams.id;
  const [player_information, setPlayerInformation] = React.useState([]);
  const [player_stats_information, setPlayerStatsInformation] = React.useState(
    []
  );
  const [page_load, setPageLoad] = React.useState(false);
  const [player_season_stats, setPlayerSeasonStats] = React.useState([]);
  const [actualPlayerDataAvailable, setActualPlayerDataAvailable] =
    React.useState(false);
  const [player_actual_season_stats, setPlayerActualSeasonStats] =
    React.useState([]);

  const [player_gamelogs, setPlayerGamelogs] = React.useState([]);

  React.useEffect(async () => {
    document.title = "Player Summary";
    props.view_setter("Players");

    props.go_back_boolean(false);

    setPageLoad(true);

    const userId = getID();
    if (process.env.REACT_APP_ENV === "production") {
      TagManager.dataLayer({
        dataLayer: {
          event: "pageview",
          userId: userId,
        },
      });
    }

    //****************************************************************** */

    //****************************************************************** */
    const slate_id = props.game_information.gameInformationReducer.slate_id;
    const dateTime =
      props.game_information.gameInformationReducer.selected_timeframe;
    console.log("======== SLATE ID =======", slate_id, dateTime);
    const league = props.game_information.gameInformationReducer.sports;
    if (league !== undefined && league !== null) {
      const sport = findSportByLeague(
        league,
        props.rcConfig,
        "index js useeffect"
      );
      const dynamic_url = [
        get_player_projections_for_slate_id(
          sport.toLowerCase(),
          league,
          slate_id,
          SSID
        ),
        get_player_projections_current(
          sport.toLowerCase(),
          league,
          SSID,
          dateTime
        ),
        get_player_stats_actual_current_season(
          sport.toLowerCase(),
          league,
          SSID,
          dateTime,
          props.rcConfig
        ),
        get_player_gamelogs_current_season(
          sport.toLowerCase(),
          league,
          SSID,
          dateTime,
          props.rcConfig
        ),
      ];

      console.log("Player Screen", dynamic_url);

      const MAX_SIMULTANEOUS_CALL = 5;

      const queue = new TaskQueue(Promise, MAX_SIMULTANEOUS_CALL);

      const startTime = Date.now();
      const jwtToken = await getUserJwtToken();
      const results = await Promise.all(
        dynamic_url.map(
          queue.wrap(
            async (url) =>
              await axios
                .get(url, {
                  headers: {
                    // "x-access-token": token,
                    "Authorization": jwtToken,
                    // ClientID: process.env.REACT_APP_COGNITO_CLIENT_ID,
                  },
                })
                .catch((error) => {
                  alert(error);
                })
          )
        )
      );

      console.log("API CALL TIME::::::");
      console.log(Date.now() - startTime);
      console.log("Response::::");
      console.log(results);

      const stats_information = results[0].data;
      const player_season_stats = results[1].data;
      const player_season_actual_stats = results[2].data;
      console.log("player actual season stats", player_season_actual_stats);
      const player_gamelogs = results[3].data;

      setPlayerGamelogs(player_gamelogs);
      setPlayerInformation(stats_information[0]);
      setPlayerStatsInformation(stats_information[0]);
      setPlayerSeasonStats(player_season_stats);
      setPlayerActualSeasonStats(player_season_actual_stats);
    }
  }, [SSID]);

  function ScrollToTopOnMount() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);

    return null;
  }

  return (
    <div className="index__main">
      <AppJS />
      <AppCSS />
      <ScrollToTopOnMount />

      {/* <MainHeader></MainHeader> */}
      <GameInformation
        view_selected={
          props.game_information.gameInformationReducer.view_selected
        }
      />
      {player_season_stats.length > 0 ? (
        <InfoComponentTop
          player_stats_information={player_stats_information}
          player_information_props={player_information}
          player_season_stats={player_season_stats}
          player_actual_season_stats={player_actual_season_stats}
          gamelogs={player_gamelogs}
          player_teamname={
            props.game_information.gameInformationReducer
              .selected_player_teamname
          }
          actual_player_data_available={actualPlayerDataAvailable}
          gameInformationReducer={props.game_information.gameInformationReducer}
          league={props.game_information.gameInformationReducer.sports}
          rcConfig={props.rcConfig}
        />
      ) : (
        <div className="App">
          <ScrollToTopOnMount />
          <SkeletonPlayerInformationSummary className="w-100" />
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    game_information: state,
    rcConfig: state.rcReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    view_setter: (value) => dispatch(setMainPageView(value)),
    go_back_boolean: (value) => dispatch(goBackBoolean(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Details);
